import { GetPaginatedForms } from '../actions/forms';

export default (store) => {
    store.dispatch(GetPaginatedForms());
};
